export const SmartViewKind = {
  HeadsUp: "HEADS_UP",
  Unknown: "UNKNOWN",
} as const;

export type SmartViewKind = (typeof SmartViewKind)[keyof typeof SmartViewKind];
